import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();

  const handleApplyNowClick = (e) => {
    e.preventDefault();
    if (!isSignedIn) {
      navigate('/user-login');
    } else {
      navigate('/application-form');
    }
  };

  return (
    <footer className="bg-card border-t border-border mt-auto">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-primary/10 rounded-md flex items-center justify-center">
                <Icon name="GraduationCap" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-lg font-heading font-semibold text-foreground">
                ChineseLangApp
              </span>
            </div>
            <p className="text-sm text-muted-foreground font-caption">
              Your gateway to Chinese language education and cultural immersion programs.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Quick Links
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground font-caption">
              <li><a href="/institution-search" className="hover:text-primary transition-smooth">Find Programs</a></li>
              <li><a href="/online-learning" className="hover:text-primary transition-smooth">Online Learning</a></li>
              <li><a href="/application-form" onClick={handleApplyNowClick} className="hover:text-primary transition-smooth">Apply Now</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Support
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground font-caption">
              <li><a href="/resources" className="hover:text-primary transition-smooth">Resources</a></li>
              <li><a href="#" className="hover:text-primary transition-smooth">Help Center</a></li>
              <li><a href="#" className="hover:text-primary transition-smooth">Contact Us</a></li>
              <li><a href="#" className="hover:text-primary transition-smooth">FAQs</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
              Legal
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground font-caption">
              <li><a href="#" className="hover:text-primary transition-smooth">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-primary transition-smooth">Terms of Service</a></li>
              <li><a href="#" className="hover:text-primary transition-smooth">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-border text-center">
          <p className="text-sm text-muted-foreground font-caption">
            &copy; {currentYear} ChineseLangApp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
